module.exports = __webpack_public_path__ + "staticesp/media/marcas (7).c1874a49.jpg";